import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import ScrollToTop from "./functions/scrollToTop"; 
import DashboardPage from './components/DashboardPage';
import SalesDashboard from './components/sales/SalesDashboard';
import SalesProfilePage from './components/sales/SalesProfilePage';
import { InvestmentProvider } from './context/InvestmentContext';
import { AuthProvider } from './context/AuthContext';
import ErrorBoundary from './components/common/ErrorBoundary';

function App() {
  return (
    <AuthProvider>
      <InvestmentProvider>
        <Router>
          <ScrollToTop /> 
          {/* A crash on any page shows a message with a retry, never a white screen. */}
          <ErrorBoundary>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/sales" element={<SalesDashboard />} />
            <Route path="/sales/profile/:number" element={<SalesProfilePage />} />
          </Routes>
          </ErrorBoundary>
        </Router>
      </InvestmentProvider>
    </AuthProvider>
  );
}

export default App;
